module.exports = __webpack_public_path__ + "static/media/avc_weight.e4709700.svg";